/**
 * A field's rule from the API's own schema (`@kanos/domain`), for React Aria's `validate`: the
 * field shows `message` on submit and while it is corrected - e.g. for a name of blanks, which
 * `isRequired` lets through.
 */
export const fieldRule = (schema, message) => (value) => schema.safeParse(value).success ? null : message;
/**
 * Checks the whole form against the schema before it is sent - the last gate behind the field
 * rules. Returns the parsed value, or `null` when something still does not fit.
 */
export function checkForm(schema, value) {
    const result = schema.safeParse(value);
    return result.success ? result.data : null;
}
/** Today as ISO date in the person's time zone - the latest date a past event can have. */
export function todayIso(now = new Date()) {
    const pad = (n) => String(n).padStart(2, '0');
    return `${String(now.getFullYear())}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}`;
}
//# sourceMappingURL=form.js.map